import * as React from 'react';
const SvgContinuousImprovement = (props) => (
  <svg viewBox="0 0 118 125" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M103.972 6.098H71.498l3.198 10.882-3.198 10.507h32.474M104.565 61.066v-58.8M36.689 12.726c-3.24-4.541-9.5-5.57-13.994-2.298-4.494 3.273-5.506 9.614-2.267 14.161 3.238 4.541 10.519 7.003 15.012 3.73 4.494-3.273 4.487-11.046 1.249-15.586v-.007ZM13.707 48.644v14.945c0 6.143-.587 12.28-1.761 18.307l-7.84 40.37M52.206 70.858c1.2-3.56-.506-7.453-3.92-8.946l-13.562-5.925"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.858 80.635c-3.11 0-5.634-2.55-5.634-5.7V50.403c0-1.452.506-2.85 1.437-3.961l5.823-6.955c3.313-3.954 8.73-5.352 13.508-3.477l3.056 1.2c5.236 2.052 8.684 7.145 8.684 12.825v19.05l17.826 7.575a7.879 7.879 0 0 1 4.682 6.027l3.26 20.461"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m15.065 122.267 10.97-41.598 21.018 6.948 2.969 15.266"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.224 61.067H91.327v22.997H66.423v23.005H41.525v15.198"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgContinuousImprovement;
